import { useContext, useMemo, useState, useEffect } from 'react';
import InlineOptions from '../../inline-options';
import { FootprintVolatilityCurvesContext } from '../../../../providers/widgets/footprint-volatility-curves-provider/footprint-volatility-curves-provider';
import Chart from '../../chart';
import Divider from '../../divider';
import { useProcessFootprintVolatilityData } from './hooks/use-process-footprint-volatility-data';
import './footprint-volatility-curves-styles.scss';
import TimestampInfo from '../../timestamp-info';

const venueOptions = [{ value: 'deribit', label: 'Deribit' }];

const FootprintVolatilityCurvesContent = () => {
  const { volatilityData, expiryList, expiry, setExpiry, isLoading, liveDataTimestamp } =
    useContext(FootprintVolatilityCurvesContext);

  const [selectedVenue, setSelectedVenue] = useState('deribit');

  const { series, xAxis, yAxis, tooltip } = useProcessFootprintVolatilityData(volatilityData || []);

  useEffect(() => {
    if (!volatilityData || !volatilityData.length) return;
  }, [volatilityData]);

  const expiryOptions = useMemo(() => {
    return expiryList.map((exp) => ({
      value: exp,
      label: exp,
    }));
  }, [expiryList]);

  const renderInlineOptions = () => (
    <div className="footprint-volatility-curves-header">
      <InlineOptions
        options={venueOptions}
        selectedOption={selectedVenue}
        onOptionChange={(val) => setSelectedVenue(val as string)}
        maxVisibleOptions={5}
      />
      <Divider />
      <InlineOptions
        options={expiryOptions}
        selectedOption={expiry}
        onOptionChange={(val) => setExpiry(val as string)}
        maxVisibleOptions={5}
      />
    </div>
  );

  const isValidDate = (date: string | number | Date) => !isNaN(new Date(date).getTime());

  return (
    <div className="footprint-volatility-curves-container">
      {renderInlineOptions()}
      <div className="footprint-volatility-curves-timestamp">
        {isValidDate(liveDataTimestamp) && (
          <TimestampInfo timestamp={new Date(liveDataTimestamp).getTime()} keepLocalTime />
        )}
      </div>
      <div className="footprint-volatility-curves-chart">
        <Chart
          series={series}
          xAxis={xAxis}
          yAxis={yAxis}
          tooltip={tooltip}
          grid={{ bottom: 0, right: 0, left: 0 }}
          isLoading={isLoading}
          legend={{
            show: false,
          }}
          merge={false}
        />
      </div>
    </div>
  );
};

export default FootprintVolatilityCurvesContent;
